import { Box, MenuItem, TextField } from '@mui/material';
import 'leaflet/dist/leaflet.css';
import Iconify from 'src/components/iconify';
import { useVisibility } from 'src/context/visibility-context';

export default function ListFilters({ setSortOrder, sortOrder }) {
  const handleChange = (event) => {
    setSortOrder(event.target.value); // Update sort order on change
  };
  const { toggleVisibility } = useVisibility();

  return (
    <Box
      sx={{ paddingTop: '30px' }}
      gap={3}
      display="grid"
      gridTemplateColumns={{
        xs: 'repeat(1, 1fr)',
        lg: 'repeat(2, 1fr)',
      }}
    >
      <Box>
        <TextField
          label="Order By"
          select
          fullWidth
          value={sortOrder}
          sx={{
            width: '300px',
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: {
                  maxHeight: 220,
                  textTransform: 'capitalize',
                },
              },
              sx: { textTransform: 'capitalize' },
            },
            sx: { textTransform: 'capitalize' },
          }}
          onChange={handleChange} // Update the sorting order on change
        >
          {['Date Ascending', 'Date Descending'].map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <Iconify
          onClick={toggleVisibility}
          style={{ height: '35px', width: '35px', cursor: 'pointer', color: '#C5C5C5' }}
          icon="line-md:map-marker-radius-filled"
        />
        <Iconify
          style={{ height: '40px', width: '40px', color: '#4CBB17', cursor: 'pointer' }}
          icon="ic:outline-menu"
        />
      </Box>
    </Box>
  );
}
